/**
 * Enum de roles/autoridades disponíveis no sistema.
 * Use sempre este enum ao verificar permissões de usuário,
 * evitando strings literais espalhadas pelo código.
 */
export const Authority = Object.freeze({
  // Roles de administração
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",

  // Roles de backoffice
  BACKOFFICE: "BACKOFFICE",
  MIGRACOES: "MIGRACOES",
  COMERCIALIZACAO: "COMERCIALIZACAO",
  PROJETOS: "PROJETOS",
  FINANCEIRO: "FINANCEIRO",
  RH: "RH",
});

/**
 * Lista de roles com acesso administrativo completo.
 */
export const ADMIN_ROLES = [Authority.ADMIN, Authority.SUPER_ADMIN];

/**
 * Lista de roles de backoffice.
 */
export const BACKOFFICE_ROLES = [
  Authority.BACKOFFICE,
  Authority.MIGRACOES,
  Authority.COMERCIALIZACAO,
  Authority.PROJETOS,
  Authority.FINANCEIRO,
  Authority.RH,
];

/**
 * Lista de todas as roles com acesso interno (admin + backoffice).
 */
export const INTERNAL_ROLES = [...ADMIN_ROLES, ...BACKOFFICE_ROLES];
